var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebdnaLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.2 196",
    style: {
      enableBackground: "new 0 0 124.2 196"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.1743,
    y1: 190.5555,
    x2: 43.1743,
    y2: -37.5105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F40056"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,116H19.5c-6.7,0-12.7-3.8-15.5-9.9c-2.8-6.1-1.9-13,2.3-18.1L72.7,4.1c2.2-2.7,6.1-3.2,8.9-1 c2.7,2.2,3.2,6.1,1,8.9L16.1,96c-1.7,2-1,4-0.6,4.8c0.4,0.8,1.5,2.6,4.1,2.6h58.1c3.5,0,6.3,2.8,6.3,6.3 C83.9,113.1,81.1,116,77.6,116z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2902,
    y1: 190.5555,
    x2: 75.2902,
    y2: -37.5105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F40056"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.8,70.1h-29c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3h29c3.5,0,6.3,2.8,6.3,6.3S93.2,70.1,89.8,70.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.9449,
    y1: 190.5555,
    x2: 81.9449,
    y2: -37.5105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F40056"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.3,48.4h-8.6c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h8.6c3.5,0,6.3,2.8,6.3,6.3 C92.6,45.5,89.7,48.4,86.3,48.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.3644,
    y1: 190.5555,
    x2: 81.3644,
    y2: -37.5105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F40056"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.9,194.3c-1.4,0-2.7-0.4-3.9-1.4c-2.7-2.2-3.2-6.1-1-8.9l66.5-84c1.7-2,1-4,0.6-4.8 c-0.4-0.8-1.5-2.6-4.1-2.6H46.9c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3H105c6.7,0,12.7,3.8,15.5,9.9c2.8,6.1,1.9,13-2.3,18.1 l-66.3,83.8C50.6,193.4,48.8,194.3,46.9,194.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.2482,
    y1: 190.5555,
    x2: 49.2482,
    y2: -37.5105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F40056"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.7,138.5h-29c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h29c3.5,0,6.3,2.8,6.3,6.3 C70,135.7,67.2,138.5,63.7,138.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.5935,
    y1: 190.5555,
    x2: 42.5935,
    y2: -37.5105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#8500AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F40056"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.9,160.3h-8.6c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3h8.6c3.5,0,6.3,2.8,6.3,6.3 S50.4,160.3,46.9,160.3z"
  })))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdnaLogoIcon);
export default __webpack_public_path__ + "static/media/webdna-logo-icon.c22d97c7757c3f15f021736663aa5e39.svg";
export { ForwardRef as ReactComponent };